export default "__VITE_ASSET__0408f76c__"